export const getAssetsFileUrl = (folder, fileName) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return `${apiUrl}/assets/${folder}/${fileName}`;
};
